export const feedbackTranslations = {
  en: {
    feedback: {
      roleplay_feedback: 'Roleplay feedback',
      roleplay_feedback_icon: 'Roleplay feedback icon',
      error: {
        load_summary: 'Could not get roleplay summary data.',
        session_not_found: 'Session ID not found.',
      },
      tabs: {
        summary: 'Summary',
        skills_assessment: 'Skills assessment',
        transcript: 'Transcript analysis',
      },
      summary: {
        overview: 'Overview',
        key_strengths: 'Key strengths',
        no_strengths:
          'No key strengths were observed in this session. Keep practicing to refine your skills!',
        areas_improvement: 'Areas for improvement',
        no_improvement_areas:
          'No areas for improvement were observed in this session. Keep up the good work!',
        next_steps: 'Suggested next steps',
      },
      assessment: {
        why: 'Why',
        what_improve: 'What to improve',
      },
      transcript: {
        you: 'You',
        ai_name: 'Emily',
        suggestion: 'Suggestion',
        warning: 'Warning',
        praise: 'Praise',
      },
    },
  },
  fr: {
    feedback: {
      roleplay_feedback: 'Retour sur le jeu de rôle',
      roleplay_feedback_icon: 'Icône de retour de jeu de rôle',
      error: {
        load_summary:
          "Impossible d'obtenir les données de résumé du jeu de rôle.",
        session_not_found: 'ID de session introuvable.',
      },
      tabs: {
        summary: 'Résumé',
        skills_assessment: 'Évaluation des compétences',
        transcript: 'Analyse de la transcription',
      },
      summary: {
        overview: 'Aperçu',
        key_strengths: 'Points forts',
        no_strengths:
          "Aucun point fort n'a été observé lors de cette session. Continuez à pratiquer pour affiner vos compétences !",
        areas_improvement: "Axes d'amélioration",
        no_improvement_areas:
          "Aucun domaine d'amélioration n'a été observé lors de cette session. Continuez votre bon travail !",
        next_steps: 'Prochaines étapes suggérées',
      },
      assessment: {
        why: 'Pourquoi',
        what_improve: 'Quoi améliorer',
      },
      transcript: {
        you: 'Vous',
        ai_name: 'Emily',
        suggestion: 'Suggestion',
        warning: 'Avertissement',
        praise: 'Éloge',
      },
    },
  },
  ja: {
    feedback: {
      roleplay_feedback: 'ロールプレイのフィードバック',
      roleplay_feedback_icon: 'ロールプレイフィードバックアイコン',
      error: {
        load_summary: 'ロールプレイの要約データを取得できませんでした。',
        session_not_found: 'セッションIDが見つかりません。',
      },
      tabs: {
        summary: '概要',
        skills_assessment: 'スキル評価',
        transcript: 'トランスクリプト分析',
      },
      summary: {
        overview: '概観',
        key_strengths: '主な強み',
        no_strengths:
          'このセッションでは主な強みは観察されませんでした。スキルを磨くために練習を続けてください！',
        areas_improvement: '改善分野',
        no_improvement_areas:
          'このセッションでは改善の余地は観察されませんでした。良い仕事を続けてください！',
        next_steps: '推奨される次のステップ',
      },
      assessment: {
        why: '理由',
        what_improve: '改善点',
      },
      transcript: {
        you: 'あなた',
        ai_name: 'エミリー',
        suggestion: '提案',
        warning: '警告',
        praise: '称賛',
      },
    },
  },
  zh: {
    feedback: {
      roleplay_feedback: '角色扮演反饋',
      roleplay_feedback_icon: '角色扮演反饋圖示',
      error: {
        load_summary: '無法獲取角色扮演摘要資料。',
        session_not_found: '未找到會話ID。',
      },
      tabs: {
        summary: '總結',
        skills_assessment: '技能評估',
        transcript: '對話分析',
      },
      summary: {
        overview: '概述',
        key_strengths: '主要優勢',
        no_strengths: '在此會話中未觀察到主要優勢。請繼續練習以提高您的技能！',
        areas_improvement: '需要改進的領域',
        no_improvement_areas:
          '在此會話中未觀察到改進的領域。請繼續保持良好的工作！',
        next_steps: '建議的下一步',
      },
      assessment: {
        why: '原因',
        what_improve: '需要改進什麼',
      },
      transcript: {
        you: '您',
        ai_name: '艾米麗',
        suggestion: '建議',
        warning: '警告',
        praise: '讚揚',
      },
    },
  },
  ko: {
    feedback: {
      roleplay_feedback: '역할극 피드백',
      roleplay_feedback_icon: '역할극 피드백 아이콘',
      error: {
        load_summary: '역할극 요약 데이터를 가져올 수 없습니다.',
        session_not_found: '세션 ID를 찾을 수 없습니다.',
      },
      tabs: {
        summary: '요약',
        skills_assessment: '기술 평가',
        transcript: '대화 분석',
      },
      summary: {
        overview: '개요',
        key_strengths: '주요 강점',
        no_strengths:
          '이 세션에서는 주요 강점이 관찰되지 않았습니다. 기술을 연마하기 위해 계속 연습하세요!',
        areas_improvement: '개선 영역',
        no_improvement_areas:
          '이 세션에서는 개선 영역이 관찰되지 않았습니다. 좋은 작업을 계속하십시오!',
        next_steps: '제안된 다음 단계',
      },
      assessment: {
        why: '이유',
        what_improve: '개선할 사항',
      },
      transcript: {
        you: '당신',
        ai_name: '에밀리',
        suggestion: '제안',
        warning: '경고',
        praise: '칭찬',
      },
    },
  },
  th: {
    feedback: {
      roleplay_feedback: 'ข้อเสนอแนะการสวมบทบาท',
      roleplay_feedback_icon: 'ไอคอนข้อเสนอแนะการสวมบทบาท',
      error: {
        load_summary: 'ไม่สามารถรับข้อมูลสรุปการสวมบทบาทได้',
        session_not_found: 'ไม่พบ Session ID',
      },
      tabs: {
        summary: 'สรุป',
        skills_assessment: 'การประเมินทักษะ',
        transcript: 'การวิเคราะห์บทสนทนา',
      },
      summary: {
        overview: 'ภาพรวม',
        key_strengths: 'จุดแข็งหลัก',
        no_strengths:
          'ไม่พบจุดแข็งหลักในเซสชันนี้ ฝึกปฏิบัติต่อไปเพื่อพัฒนาทักษะของคุณ!',
        areas_improvement: 'จุดที่ควรปรับปรุง',
        no_improvement_areas:
          'ไม่พบจุดที่ควรปรับปรุงในเซสชันนี้ ทำต่อไปเช่นนี้!',
        next_steps: 'ขั้นตอนถัดไปที่แนะนำ',
      },
      assessment: {
        why: 'เพราะเหตุใด',
        what_improve: 'สิ่งที่ควรปรับปรุง',
      },
      transcript: {
        you: 'คุณ',
        ai_name: 'เอมิลี่',
        suggestion: 'คำแนะนำ',
        warning: 'คำเตือน',
        praise: 'คำชื่นชม',
      },
    },
  },
  id: {
    feedback: {
      roleplay_feedback: 'Umpan balik bermain peran',
      roleplay_feedback_icon: 'Ikon umpan balik bermain peran',
      error: {
        load_summary: 'Tidak dapat mengambil data ringkasan bermain peran.',
        session_not_found: 'ID sesi tidak ditemukan.',
      },
      tabs: {
        summary: 'Ringkasan',
        skills_assessment: 'Penilaian keterampilan',
        transcript: 'Analisis transkrip',
      },
      summary: {
        overview: 'Tinjauan',
        key_strengths: 'Kekuatan utama',
        no_strengths:
          'Tidak ada kekuatan utama yang diamati dalam sesi ini. Terus berlatih untuk mengasah keterampilan Anda!',
        areas_improvement: 'Area untuk perbaikan',
        no_improvement_areas:
          'Tidak ada area perbaikan yang diamati dalam sesi ini. Pertahankan kerja yang baik!',
        next_steps: 'Langkah selanjutnya yang disarankan',
      },
      assessment: {
        why: 'Mengapa',
        what_improve: 'Apa yang harus diperbaiki',
      },
      transcript: {
        you: 'Anda',
        ai_name: 'Emily',
        suggestion: 'Saran',
        warning: 'Peringatan',
        praise: 'Pujian',
      },
    },
  },
  tl: {
    feedback: {
      roleplay_feedback: 'Puna sa roleplay',
      roleplay_feedback_icon: 'Icon ng puna sa roleplay',
      error: {
        load_summary: 'Hindi makuha ang data ng buod ng roleplay.',
        session_not_found: 'Hindi nahanap ang session ID.',
      },
      tabs: {
        summary: 'Buod',
        skills_assessment: 'Pagtatasa ng kakayahan',
        transcript: 'Pagsusuri ng talaan',
      },
      summary: {
        overview: 'Pangkalahatang-ideya',
        key_strengths: 'Mga pangunahing lakas',
        no_strengths:
          'Walang mga pangunahing lakas na naobserbahan sa sesyon na ito. Patuloy na mag-ensayo upang mapahusay ang inyong mga kakayahan!',
        areas_improvement: 'Mga lugar para sa pagpapabuti',
        no_improvement_areas:
          'Walang mga lugar na para sa pagpapabuti na naobserbahan sa sesyon na ito. Ipagpatuloy ang magandang gawain!',
        next_steps: 'Mga iminungkahing susunod na hakbang',
      },
      assessment: {
        why: 'Bakit',
        what_improve: 'Ano ang dapat mapabuti',
      },
      transcript: {
        you: 'Ikaw',
        ai_name: 'Emily',
        suggestion: 'Mungkahi',
        warning: 'Babala',
        praise: 'Papuri',
      },
    },
  },
  ms: {
    feedback: {
      roleplay_feedback: 'Maklum balas lakonan peranan',
      roleplay_feedback_icon: 'Ikon maklum balas lakonan peranan',
      error: {
        load_summary: 'Tidak dapat mengambil data ringkasan lakonan peranan.',
        session_not_found: 'ID sesi tidak dijumpai.',
      },
      tabs: {
        summary: 'Ringkasan',
        skills_assessment: 'Penilaian kemahiran',
        transcript: 'Analisis transkrip',
      },
      summary: {
        overview: 'Tinjauan',
        key_strengths: 'Kekuatan utama',
        no_strengths:
          'Tiada kekuatan utama yang diperhatikan dalam sesi ini. Terus berlatih untuk mengasah kemahiran anda!',
        areas_improvement: 'Bidang untuk penambahbaikan',
        no_improvement_areas:
          'Tiada bidang penambahbaikan yang diperhatikan dalam sesi ini. Teruskan kerja yang baik!',
        next_steps: 'Langkah seterusnya yang dicadangkan',
      },
      assessment: {
        why: 'Mengapa',
        what_improve: 'Apa yang perlu diperbaiki',
      },
      transcript: {
        you: 'Anda',
        ai_name: 'Emily',
        suggestion: 'Cadangan',
        warning: 'Amaran',
        praise: 'Pujian',
      },
    },
  },
    sw: {
      feedback: {
        roleplay_feedback: 'Maoni ya uigizaji wa majukumu',
        roleplay_feedback_icon: 'Ikoni ya maoni ya uigizaji wa majukumu',
        error: {
          load_summary: 'Haikuweza kupata data ya muhtasari wa uigizaji.',
          session_not_found: 'Kitambulisho cha kikao hakijapatikana.',
        },
        tabs: {
          summary: 'Muhtasari',
          skills_assessment: 'Tathmini ya ujuzi',
          transcript: 'Uchambuzi wa mazungumzo',
        },
        summary: {
          overview: 'Muhtasari',
          key_strengths: 'Nguvu kuu',
          no_strengths:
            'Hakuna nguvu kuu zilizobainika katika kikao hiki. Endelea kufanya mazoezi ili kuboresha ujuzi wako!',
          areas_improvement: 'Maeneo ya kuboresha',
          no_improvement_areas:
            'Hakuna maeneo ya kuboresha yaliyoonekana katika kikao hiki. Endelea na kazi nzuri!',
          next_steps: 'Hatua zinazopendekezwa',
        },
        assessment: {
          why: 'Kwa nini',
          what_improve: 'Nini kiboreshe',
        },
        transcript: {
          you: 'Wewe',
          ai_name: 'Emily',
          suggestion: 'Pendekezo',
          warning: 'Onyo',
          praise: 'Sifa',
        },
      },
    },
    vi: {
      feedback: {
        roleplay_feedback: 'Phản hồi thực hành',
        roleplay_feedback_icon: 'Biểu tượng phản hồi thực hành',
        error: {
          load_summary: 'Không thể lấy dữ liệu tóm tắt thực hành.',
          session_not_found: 'Không tìm thấy ID phiên.',
        },
        tabs: {
          summary: 'Tóm tắt',
          skills_assessment: 'Đánh giá kỹ năng',
          transcript: 'Phân tích cuộc trò chuyện',
        },
        summary: {
          overview: 'Tổng quan',
          key_strengths: 'Điểm mạnh chính',
          no_strengths:
            'Không có điểm mạnh nổi bật nào được ghi nhận trong phiên này. Hãy tiếp tục luyện tập để nâng cao kỹ năng!',
          areas_improvement: 'Lĩnh vực cần cải thiện',
          no_improvement_areas:
            'Không có lĩnh vực cần cải thiện nào được ghi nhận trong phiên này. Hãy tiếp tục phát huy!',
          next_steps: 'Bước tiếp theo được đề xuất',
        },
        assessment: {
          why: 'Tại sao',
          what_improve: 'Cần cải thiện gì',
        },
        transcript: {
          you: 'Bạn',
          ai_name: 'Emily',
          suggestion: 'Gợi ý',
          warning: 'Cảnh báo',
          praise: 'Khen ngợi',
        },
      },
    },
};
